import select from '@signal/utils/select'
import { getSignalFontVariantName } from '../utils'
import {
  createThemeSelector,
  createVariableThemeSelectorCreator
} from './utils'

export const typographySelector = createThemeSelector(theme => theme.typography)

export const getPxToRemSelector = createVariableThemeSelectorCreator(fontSize =>
  createThemeSelector(typographySelector, typography =>
    typography.pxToRem(fontSize)
  )
)

export const getTypographyVariantSelector = createVariableThemeSelectorCreator(
  variant =>
    createThemeSelector(
      typographySelector,
      select(getSignalFontVariantName(variant))
    )
)
